var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ol',{staticClass:"breadcrumb center-items"},[_vm._m(0),_c('li',[_c('a',{attrs:{"href":this.link}},[_vm._v(_vm._s(this.linkTitle))])]),_c('li',{staticClass:"active"},[_vm._v(_vm._s(this.title))])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('li',[_c('a',{attrs:{"href":"/"}},[_vm._v("Home")])])
}]

export { render, staticRenderFns }